import { LiquorIcon } from './LiquorIcon';

/**
 * author: Google
 * id 48C6596F-07B5-495C-82E2-683B09DD7040
 * name liquor
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/liquor.svg
 * tags
 * - Food / Drink 
 */
export const BeveragesIcon = LiquorIcon;
export default BeveragesIcon